module.exports = __webpack_public_path__ + "static/7-d333269fff4e45805824d041bb712879.jpg";